import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default function useFetchFromBackend({
  path,
  params = {},
  queryKey,
  options,
}) {
  const query = useQuery({
    queryKey: queryKey || [path, params],
    queryFn: async () => {
      const response = await axios.get(`${baseUrl}${path}`, {
        params,
      });
      return response.data;
    },
    ...options,
  });

  const { data, error, isLoading } = query;

  return { data, error, isLoading };
}
